import { render } from "./ContactPersonMergeView.vue?vue&type=template&id=6cd5cb32"
import script from "./ContactPersonMergeView.vue?vue&type=script&lang=js"
export * from "./ContactPersonMergeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__